module.exports = __webpack_public_path__ + "img/充电桩概览2.bc3b3835.png";